/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserKrrInfoResponse
 */
export interface UserKrrInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof UserKrrInfoResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserKrrInfoResponse
     */
    mobileNr?: string | null;
}

/**
 * Check if a given object implements the UserKrrInfoResponse interface.
 */
export function instanceOfUserKrrInfoResponse(value: object): value is UserKrrInfoResponse {
    return true;
}

export function UserKrrInfoResponseFromJSON(json: any): UserKrrInfoResponse {
    return UserKrrInfoResponseFromJSONTyped(json, false);
}

export function UserKrrInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserKrrInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'mobileNr': json['mobileNr'] === undefined ? undefined : json['mobileNr'] === null ? null : json['mobileNr'],
    };
}

export function UserKrrInfoResponseToJSON(json: any): UserKrrInfoResponse {
    return UserKrrInfoResponseToJSONTyped(json, false);
}

export function UserKrrInfoResponseToJSONTyped(value?: UserKrrInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'mobileNr': value['mobileNr'],
    };
}

